import React from 'react'

export class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error('App error:', error, info)
  }

  render() {
    const clearCachesAndReload = async () => {
      try {
        if (typeof navigator !== 'undefined' && navigator.serviceWorker?.getRegistrations) {
          const regs = await navigator.serviceWorker.getRegistrations()
          await Promise.all(regs.map((r) => r.unregister().catch(() => {})))
        }
      } catch {}
      try {
        if (typeof caches !== 'undefined' && caches.keys) {
          const keys = await caches.keys()
          await Promise.all(keys.map((k) => caches.delete(k).catch(() => false)))
        }
      } catch {}
      window.location.reload()
    }

    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          padding: '2rem',
          background: '#0f1419',
          color: '#f0f4f8',
          fontFamily: "'Heebo', system-ui, sans-serif",
          direction: 'rtl',
          textAlign: 'center',
        }}>
          <h1 style={{ marginBottom: '1rem', fontWeight: 600 }}>אירעה שגיאה</h1>
          <p style={{ color: '#94a3b8', marginBottom: '1.25rem', fontSize: '0.95rem' }}>
            {this.state.error?.message || 'נסה לרענן את הדף'}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: '0.7rem 1.35rem',
              background: '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '0.95rem',
              fontWeight: 500,
            }}
          >
            רענן דף
          </button>
          <button
            type="button"
            onClick={clearCachesAndReload}
            style={{
              padding: '0.65rem 1.15rem',
              background: '#0b1220',
              color: '#e2e8f0',
              border: '1px solid #334155',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: 500,
              marginInlineStart: '0.75rem',
            }}
          >
            נקה מטמון ונסה שוב
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
